import { useUser } from "@/hooks/useUser";
import { isKickstarterAccount } from "@/utils/isKickstarterAccount";

import { KickstarterBanner } from "./index";

type KickstarterBannerWrapperProps = {
  description: string;
  dismissible?: boolean;
  onDismiss?: () => void;
  primaryButtonOnClick?: () => void;
  primaryButtonText?: string;
  secondaryButtonOnClick?: () => void;
  secondaryButtonText?: string;
  title: string;
};

/**
 * Wrapper component that only shows the banner if the current user account is kickstarter
 */
export function KickstarterBannerWrapper({
  description,
  dismissible = false,
  onDismiss,
  primaryButtonOnClick,
  primaryButtonText,
  secondaryButtonOnClick,
  secondaryButtonText,
  title,
}: KickstarterBannerWrapperProps) {
  const { data } = useUser();

  if (!isKickstarterAccount(data?.user.accountType ?? null)) {
    return null;
  }

  return (
    <KickstarterBanner
      description={description}
      dismissible={dismissible}
      onDismiss={onDismiss}
      primaryButtonOnClick={primaryButtonOnClick}
      primaryButtonText={primaryButtonText}
      secondaryButtonOnClick={secondaryButtonOnClick}
      secondaryButtonText={secondaryButtonText}
      title={title}
    />
  );
}
